import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'components/bolt/header/header.js';
// import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	componentDidMount() {
		super.componentDidMount();
		Store.on('TOGGLE_REGION_SELECTOR', this.toggleRegionSelector);
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		Store.off('TOGGLE_REGION_SELECTOR', this.toggleRegionSelector);
	}

}
